import React from 'react'
import XLSX from 'xlsx'
import FileSaver from 'file-saver'
import ReportContractorWage from './ReportContractorWage'

export default class ExcelEmployeeWage extends React.Component {
  constructor(props) {
    super(props)

  }

  componentDidMount() {
    console.log(this.reportEmployeeWage)
    const worksheet = XLSX.utils.table_to_book(document.getElementById('employee'));
    // let wb = new Workbook()
    // wb.SheetNames.push('worksheet')
    // wb.Sheets['worksheet'] = worksheet
    let wbout = XLSX.write(worksheet, { bookType: 'xlsx', bookSST: true, type: 'binary' });

    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }
    FileSaver.saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), "test.xlsx")
  }

  render() {
    return (
      <div>
        <p>Helo XLSX</p>
        <ReportContractorWage ref={ref => this.reportEmployeeWage = ref} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/view/hr/report/ExcelEmployeeWage.js